/**
 * Страница 'Правовая информация'
 *
 * @param {Object} params
 * @param {String} params.textDocument - блок с текстовым документом
 */
$.fn.legalInformationItem = function (params) {

    const $self = $(this);
    const textDocument = params.textDocument;

    /**
     * Добавление к url якоря выбранного блока с текстовым документом
     */
    $self.on('click', textDocument, function () {

        let anchor = $(this).attr('id');
        location.hash = '#' + anchor;
    });

    return this;
};

// инициализация
const init = function () {

    $('#legal-information-module').legalInformationItem({
        textDocument: '[data-text-document="true"]',
    });
};

if ($('#legal-information-module').length > 0) {
    init();
}